import "drag-drop-touch";

import Vue from "vue";
import App from "./App.vue";
import VTooltip from "v-tooltip";
import VueDragDrop from "vue-drag-drop";
import AxL from "./axl.js";
import grids from "./grids";

Vue.use(VueDragDrop);

Vue.use(VTooltip);

Vue.config.productionTip = false;

const emptyFunc = () => {};

const url = new URL(location.href);
if (url.searchParams.get("optout")) {
  console.log(`No AXL needed here`);
  const devLevel = 0;
  new Vue({
    render: (h) => {
      return h(App, {
        props: {
          axl: {
            sendMessage: emptyFunc,
            storage: {
              getItem: emptyFunc,
              setItem: emptyFunc,
              removeItem: emptyFunc,
            },
          },
          saved_grid: grids[devLevel],
          saved_level: devLevel,
          saved_maxLevel: 10,
          tooltipViewed: true,
        },
      });
    },
  }).$mount("#app");
} else {
  const axl = new AxL();
  let isInLine = false;
  console.log("Start AXL handshake");
  axl
    .handshake()
    .then(async (params) => {
      console.log(params);
      console.log("Handshake completed !");

      if(params.isInLine){
        isInLine = params.isInLine;
      }

      const level = (await axl.storage.getItem("currentLevel")) || 0;
      const maxLevel = (await axl.storage.getItem("maxLevel")) || 0;
      const id = grids[level].id;
      console.log(id);
      const grid = (await axl.storage.getItem(`grid-${id}`)) || grids[level];

      const tooltipViewed =
        (await axl.storage.getItem("tooltipViewed")) || false;
      console.log(grid);
      console.log(axl);

      new Vue({
        render: (h) => {
          return h(App, {
            props: {
              axl: axl,
              saved_grid: grid,
              saved_level: level,
              saved_maxLevel: maxLevel,
              tooltipViewed: tooltipViewed,
              isInLine: isInLine,
            },
          });
        },
      }).$mount("#app");
    })
    .catch((e) => {
      console.log(e);
    });
}
